import { MutationTree } from "vuex";
import { ExternalMenuLink, ExternalMenuLinkState } from "./types";
import Vue from "vue";

export const mutations: MutationTree<ExternalMenuLinkState> = {
	setExternalMenuLinks(state, externalMenuLinks: ExternalMenuLink[]) {
		state.externalMenuLinks = externalMenuLinks;
	},

	removeExternalMenuLink(state, customMenuLinkId: number) {
		const index = state.externalMenuLinks.findIndex(
			(item: ExternalMenuLink) => item.externalMenuLinkId === customMenuLinkId
		);
		state.externalMenuLinks.splice(index, 1);
	},

	addNewExternalMenuLink(state, externalMenuLink: ExternalMenuLink) {
		if (
			state.externalMenuLinks.findIndex(
				(x: ExternalMenuLink) => x.externalMenuLinkId == externalMenuLink.externalMenuLinkId
			) == -1
		) {
			state.externalMenuLinks.push(externalMenuLink);
		}
	},

	updateExternalMenuLink(state, externalMenuLink: ExternalMenuLink) {
		const index = state.externalMenuLinks.findIndex(
			(item: ExternalMenuLink) => item.externalMenuLinkId === externalMenuLink.externalMenuLinkId
		);

		if (index >= 0) {
			Vue.set(state.externalMenuLinks, index, externalMenuLink);
		}
	}
};
